import {
  createClearType,
  createErrorType,
  createLoadingType,
  createSubmitType,
  createSuccessType,
} from '../actionHelpers';

// Refer a friend button clicked
const REFER_A_FRIEND_SCOPE = 'REFER_A_FRIEND_SCOPE';
export const REFER_A_FRIEND = createSubmitType(REFER_A_FRIEND_SCOPE);
export const REFER_A_FRIEND_LOADING = createLoadingType(REFER_A_FRIEND_SCOPE);
export const REFER_A_FRIEND_SUCCESS = createSuccessType(REFER_A_FRIEND_SCOPE);
export const REFER_A_FRIEND_ERROR = createErrorType(REFER_A_FRIEND_SCOPE);
export const REFER_A_FRIEND_EMPTY = createClearType(REFER_A_FRIEND_SCOPE);
